import { KeywordSearch } from "@molecules/index"

import useTable from "@organisms/Table/Table.context"

export default function TableKeywordSearch() {
    const { searchKeywords, setSearchKeywords } = useTable()

    return <KeywordSearch defaultValue={searchKeywords} onValueChange={setSearchKeywords} />
}
